import lib from "./../../js-lib/lib.js";
import cacher from "./../../js-lib/cacher.js";
import toggler from "./../../js-lib/toggler.js";
import Eco from "./Eco";

const Theme = {
  load_cache: (state) => {
    // Load Theme Cache
    state["theme"] = cacher.retrieve("theme")
      ? cacher.retrieve("theme")
      : state.theme;
  },
  on: (state) => {
    toggler.on(lib.qs(".global-js-theme-light"), state.theme);
    Eco.themeOff(state);
    Theme.render(state);
  },
  off: (state) => {
    toggler.off(lib.qs(".global-js-theme-dark"), state.theme);
    Eco.themeOff(state);
    Theme.render(state);
  },
  ecoOff: (state) => {
    toggler.on(lib.qs(".global-js-theme-light"), state.theme);
    Theme.render(state);
  },
  global_scope: (state, callback = null) => {
    // Toggle Light and Dark Globally
    toggler.toggle(
      lib.qsa(".global-js--toggle"),
      state.theme,
      Theme.render.bind(this, state)
    );
    // toggler.toggle(
    //   lib.qsa(".js--toggle"),
    //   state.theme,
    //   Theme.render.bind(this, state)
    // );

    // Global Toggle Actions
    lib.qsa(".global-js-theme-light").forEach((elem) =>
      elem.addEventListener("click", (e) => {
        Theme.off(state);
        callback(state);
        window.App.scope(); // Re-render the Application Scope
      })
    );

    lib.qsa(".global-js-theme-dark").forEach((elem) =>
      elem.addEventListener("click", (e) => {
        Theme.on(state);
        callback(state);
        window.App.scope(); // Re-render the Application Scope
      })
    );
  },
  scope: (state) => {},
  render: (state) => {
    // Render Light / Dark States
    // toggler.render(lib.qs(".js--toggle"), state.theme);
    // toggler.render(lib.qs(".global-js--toggle"), state.theme);

    // Render Light / Dark States
    toggler.render(lib.qs(".global-js-theme-light"), state.theme);
    toggler.render(lib.qs(".global-js-theme-dark"), state.theme);

    cacher.store("theme", state.theme);
  },
};

export { Theme as default };
